// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"841b491c","496":"e1a1d414"}[chunkId] + ".chunk.css";
};